import React from 'react';

export const UserIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        width="14"
        height="17"
        viewBox="0 0 14 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.057.933a4.178 4.178 0 100 8.356 4.178 4.178 0 000-8.356zM4.67 2.723A3.378 3.378 0 119.446 7.5a3.378 3.378 0 01-4.777-4.777zm-1.73 9.604a5.822 5.822 0 019.925 3.717H1.247a5.822 5.822 0 011.691-3.716zm4.116-2.505a6.622 6.622 0 00-6.622 6.622.4.4 0 00.4.4h12.444a.4.4 0 00.4-.4 6.622 6.622 0 00-6.622-6.622z"
            fill="currentColor"
        />
    </svg>
);
